export default "__VITE_ASSET__8b1d049a__"